import { useState } from 'react'

import { Button, DrawerBodyWrapper, DrawerFooterWrapper, SectionHeader, Textarea } from '@base'
import { strings } from '@constants'
import { InputWrapper } from '../../Financial/Pdc/PdcForm'
import ProbeAddressCard from '../Components/ProbeAddressCard'

const deriveFormState = (oldState) => {
	const _state = {}
	return _state
}

const AuthorizedSignatoryInput = ({ signatoryData }) => {
	const [formState, setFormState] = useState(deriveFormState())

	const submitHandler = () => {}

	return (
		<>
			<DrawerBodyWrapper>
				<ProbeAddressCard data={signatoryData?.address} heading={strings('address')} />
				<SectionHeader></SectionHeader>
				<InputWrapper>
					<Textarea
						label={'comments on overall management'}
						value={'Comments on overall management plans and risk apetite'}
						onChange={() => {}}
					/>
				</InputWrapper>
			</DrawerBodyWrapper>
			<DrawerFooterWrapper>
				<Button margin={`0 0 0 auto`} small uppercase type='primary' disabled={false} onClick={submitHandler}>
					{strings('submit')}
				</Button>
				{/* <Button small uppercase type='secondary' variant='destructive' onClick={clearSearch}>
					Clear
				</Button> */}
			</DrawerFooterWrapper>
		</>
	)
}

export default AuthorizedSignatoryInput
